const AVATAR_NAVIGATION_ORIGIN = 'https://avatars.imai.local';

export function workspaceAvatarReturnPath(args: {
  orgSlug: string;
  returnTo?: string | null;
}): string | null {
  const { orgSlug, returnTo } = args;
  if (
    !returnTo?.startsWith('/') ||
    returnTo.startsWith('//') ||
    returnTo.includes('\\')
  ) {
    return null;
  }

  const parsed = new URL(returnTo, AVATAR_NAVIGATION_ORIGIN);
  const designPath = `/${orgSlug}/design`;
  const exactEntityPathPrefixes = [
    `/${orgSlug}/threads/`,
    `/${orgSlug}/products/`,
    `/${orgSlug}/projects/`,
  ];
  const entityId = exactEntityPathPrefixes
    .map((prefix) =>
      parsed.pathname.startsWith(prefix)
        ? parsed.pathname.slice(prefix.length)
        : ''
    )
    .find(Boolean);
  const isComposerPath =
    parsed.pathname === designPath ||
    (Boolean(entityId) &&
      !entityId?.includes('/') &&
      !/%2f/i.test(entityId ?? ''));

  if (parsed.origin !== AVATAR_NAVIGATION_ORIGIN || !isComposerPath) {
    return null;
  }

  return `${parsed.pathname}${parsed.search}${parsed.hash}`;
}
